import {ArrowBack} from '@mui/icons-material'
import {Box, Typography, Button} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

interface FieldEditorHeaderProps {
  onBack: () => void
}

/**
 * FieldEditorHeader Component
 *
 * Header with back button navigation for field editing.
 * Displays "Edit order" title with back arrow button.
 */
export const FieldEditorHeader: React.FC<FieldEditorHeaderProps> = ({onBack}) => {
  const {t} = useTranslation()

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Button
          onClick={onBack}
          sx={{
            minWidth: 'auto',
            padding: '4px',
            color: '#016ad4',
            marginRight: '12px'
          }}
          data-test-id="field-editor-back-button"
        >
          <ArrowBack sx={{fontSize: '16px'}} />
        </Button>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '24px',
            color: '#29333d',
            fontFamily: 'Inter'
          }}
        >
          {t('orderIntake.rmc.orderManagement.editOrder', 'Edit order')}
        </Typography>
      </Box>
    </Box>
  )
}
